import { periodLabels } from "@/modules/metal/offer/period.tsx";
import type { MetalCommitmentPeriodEnum } from "@warrenio/api-spec/spec.oats.gen";

export function BillingCycle({ value }: { value: MetalCommitmentPeriodEnum | undefined }) {
    if (value === undefined) return null;
    return periodLabels[value];
}
